import { render } from "./MultipleSelection.vue?vue&type=template&id=2cf9f80c&scoped=true"
import script from "./MultipleSelection.vue?vue&type=script&lang=js"
export * from "./MultipleSelection.vue?vue&type=script&lang=js"

import "./MultipleSelection.vue?vue&type=style&index=0&id=2cf9f80c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf9f80c"]])

export default __exports__